import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M16.45 8c.198.275.308.63.308 1s-.11.726-.308 1c-1.255 1.686-4.114 4.968-7.45 4.968S2.806 11.686 1.55 10a1.7 1.7 0 0 1-.308-1c0-.37.11-.725.308-1C2.806 6.315 5.664 3.032 9 3.032S15.195 6.315 16.45 8"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M9 11.387a2.387 2.387 0 1 0 0-4.774 2.387 2.387 0 0 0 0 4.774"
    }, null, -1)
  ])))
}
export default { render: render }